module.exports = __webpack_public_path__ + "static/media/waze.dd3508bf.png";